import { SyntheticEvent } from 'react';

import { usePathwaySteps } from '@/hooks';
import {
  FetchAutocomplete,
  FetchAutocompleteChangeReason,
} from '@australiangreens/ag-internal-components';
import { AccordionField } from '@components/DrawerAccordion';

type VolunteerPathwaysFormProps = {
  onChange: (
    newValue: { label: string; id: number }[],
    reason: FetchAutocompleteChangeReason,
    event: SyntheticEvent<Element, Event>
  ) => void;
  value: { label: string; id: number }[];
};

export default function VolunteerPathwaysForm({
  value = [],
  onChange = () => {},
}: VolunteerPathwaysFormProps) {
  const { data: pathwaySteps } = usePathwaySteps();
  return (
    <AccordionField>
      <FetchAutocomplete
        minLength={0}
        label="Select a step"
        preLoadedOptions={pathwaySteps ?? []}
        value={value}
        onChange={onChange}
        data-testid="supporterstatuses"
        loadingText="Looking for Pathway Steps..."
        noOptionsText="No Pathway Steps found"
      />
    </AccordionField>
  );
}
